import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import portfolioService from '../services/portfolio';

const ETFList = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const { data: etfs, isLoading, error } = useQuery({
    queryKey: ['etfs'],
    queryFn: () => portfolioService.getETFs(),
  });

  const filteredETFs = etfs?.filter(etf =>
    etf.ticker.toLowerCase().includes(searchTerm.toLowerCase()) ||
    etf.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (isLoading) return <div className="text-center p-4" style={{ color: '#71717a' }}>Loading ETFs...</div>;
  if (error) return <div className="text-center p-4 text-danger">Error loading ETFs</div>;

  return (
    <div className="container-fluid py-4 px-0">
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h1 className="fw-semibold mb-1" style={{ color: '#000537', letterSpacing: '-0.025em' }}>ETFs</h1>
          <p style={{ color: '#71717a', fontSize: '0.875rem', margin: 0 }}>{etfs?.length ?? 0} funds in database</p>
        </div>
      </div>

      {/* Search */}
      <div className="mb-4" style={{ maxWidth: '400px' }}>
        <div className="position-relative">
          <div className="position-absolute top-50 translate-middle-y" style={{ left: '12px', color: '#a1a1aa', pointerEvents: 'none' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search by name or ticker…"
            className="form-control"
            style={{ paddingLeft: '36px', fontSize: '0.875rem' }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {filteredETFs && filteredETFs.length > 0 ? (
        <div className="card" style={{ border: '1px solid #f4f4f5', borderRadius: '12px', overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}><div style={{ minWidth: 560 }}>
          {/* Table header */}
          <div style={{ borderBottom: '1px solid #f4f4f5', padding: '10px 20px', display: 'grid', gridTemplateColumns: '100px 1fr 140px 120px 100px', gap: '12px', alignItems: 'center' }}>
            <span className="section-label">Ticker</span>
            <span className="section-label">Name</span>
            <span className="section-label">Provider</span>
            <span className="section-label">Updated</span>
            <span></span>
          </div>
          {/* Rows */}
          {filteredETFs.map((etf, idx) => (
            <div
              key={etf.id}
              style={{
                padding: '12px 20px',
                display: 'grid',
                gridTemplateColumns: '100px 1fr 140px 120px 100px',
                gap: '12px',
                alignItems: 'center',
                borderBottom: idx < filteredETFs.length - 1 ? '1px solid #f4f4f5' : 'none',
                transition: 'background-color 0.15s ease',
              }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#fafafa')}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <span style={{ fontWeight: 600, fontSize: '0.875rem', color: '#000537', fontFamily: 'monospace' }}>{etf.ticker}</span>
              <span style={{ fontSize: '0.875rem', color: '#18181b' }}>{etf.name}</span>
              <span style={{ fontSize: '0.8rem', color: '#71717a' }}>{etf.provider.name}</span>
              <span style={{ fontSize: '0.8rem', color: '#a1a1aa' }}>
                {etf.last_updated_at ? new Date(etf.last_updated_at).toLocaleDateString() : '—'}
              </span>
              <div className="text-end">
                <Link
                  to={`/etfs/${etf.id}`}
                  style={{ fontSize: '0.8rem', color: '#000537', textDecoration: 'none', fontWeight: 500 }}
                  onMouseEnter={e => (e.currentTarget.style.opacity = '0.6')}
                  onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
                >
                  Details →
                </Link>
              </div>
            </div>
          ))}
          </div></div>{/* scroll wrapper */}
        </div>
      ) : (
        <div className="card text-center" style={{ border: '1px solid #f4f4f5', borderRadius: '12px', padding: '3rem' }}>
          <div style={{ color: '#d4d4d8', marginBottom: '12px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
            </svg>
          </div>
          <div className="fw-medium mb-1" style={{ color: '#18181b' }}>
            {searchTerm ? 'No ETFs match your search' : 'No ETFs available'}
          </div>
          <div style={{ fontSize: '0.875rem', color: '#71717a' }}>
            {searchTerm ? 'Try a different search term' : 'ETF data will appear here once synchronized'}
          </div>
        </div>
      )}
    </div>
  );
};

export default ETFList;
